import { TDevice } from '@cian/utils';
import { ESiteType } from '../../types/analytics';

export const getSiteType = (deviceType: TDevice | undefined = 'desktop'): ESiteType =>
  deviceType === 'phone' ? ESiteType.mobile : ESiteType[deviceType];
